export enum AccessTypeEnum {
  Subscription = 'subscription',
  Free = 'free',
  Iap = 'iap',
  IapAndSubscription = 'iap_and_subscription',
}
